import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { ISummaryGroupedObjectsDTO, ISummarySearchDTO } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export type UseGroupedSetpointDataParams = {
    groupID: number,
    objectType: eLynxObjectTypeEnum,
    //page: number,
    //pageSize: number,
    searchCriteria: ISummarySearchDTO,
} & BaseUseQueryParameters<ISummaryGroupedObjectsDTO | undefined>;

export function useGroupedSetpointData({
    groupID,
    objectType,
    //page,
    //pageSize,
    searchCriteria,
    enabled,    
    onSuccess,
    onError
}: UseGroupedSetpointDataParams) {
    return useQuery<ISummaryGroupedObjectsDTO, RestError>(
        keys.groupedSetPoints(groupID, 
            objectType,
            searchCriteria,
        ),
        ({ signal }) => {
            return SetpointAdministrationDataService.getGroupedSetpoints(
                groupID, 
                objectType,
                searchCriteria,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            refetchOnMount: true
        }
    );
}